import React from "react";
import {
  Card,
  CardBody,
  CardFooter,
  Row,
  Col,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button
} from "reactstrap";
import * as WebDataRocksReact from './webdatarocks.react';
import SiniaCustomChart from "../components/charts/sinia-custom-chart.component";
import Api from "../components/ApiService";
import StringUtils from "../components/StringUtils";
import Select from "../components/SelectBox";
import SelectSerie from "../components/SelectSerie";
const default_select = [
  { value: "00", label: "Serie Nacional" },
  { value: "01", label: "Serie Departamental" },
];

class Ficha extends React.Component {
  constructor(props) {
    super(props);
    let me = this;
    me.urlParams = StringUtils.getUrlParams(props.location.search);
    this.state = {
      store_series: [],
      store_series_default: '',
      store_series_selected:[],
      ficha_info: {
        id: "",
        nombre: "",
        fuente: "",
        dependencia: "",
        unidad: "",
        unidad_sigla: ""
      },
      store_ambitos: [],
      store_ambitos_default: [{ value: '', label: 'Todos' }],
      store_ambitos_selected: [],
      store_periodos: [],
      store_periodos_default: [{ value: '', label: 'Todos' }],
      store_periodos_selected: [],
      grid_header: {},
      grid_data: [],
      store_chart_data: { category: [], datos: [] },
      store_chart_all: [],
      new_store_serie: true,
      isModalOpen: false
    };
    this.chart = React.createRef();
    this.onChangeSerie = this.onChangeSerie.bind(this);
    this.onChangePeriodo = this.onChangePeriodo.bind(this);
    this.onChangeAmbito = this.onChangeAmbito.bind(this);
    this.showModal = this.showModal.bind(this);
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      isModalOpen: !this.state.isModalOpen
    });
  }

  showModal() {
    this.setState({
      isModalOpen: true
    });
  }
  componentDidMount() {
    let me = this;
    Api({
      query: "ANA02",
      serie: me.urlParams.indicador
    }, function (items) {
      if (items.ANA02 && items.ANA02.data.length) {
        me.setState({
          ficha_info: items.ANA02.data[0],
        });
      }
    });
    Api({
      query: "ANA03",
      serie: me.urlParams.indicador
    }, function (items) {
      if (items.ANA03 && items.ANA03.data.length) {
        let new_store_serie = [];
        let new_store_serie_selected=[];
        items.ANA03.data.map(function (item, i) {
          new_store_serie.push({ value: item.id, label: item.nombre });
          if(me.urlParams.serie){
             if(item.id==me.urlParams.serie){
              new_store_serie_selected.push({ value: item.id, label: item.nombre });
             }
          }
        });
        if(new_store_serie_selected.length==0){
          new_store_serie_selected.push(new_store_serie[0]);
        }
        me.setState({
          store_series: new_store_serie,
          store_series_default: new_store_serie_selected[0].value,
          store_series_selected:new_store_serie_selected
        }, () => me.processingDataRemote(new_store_serie_selected[0].value, null, null));
      }
    });
  }
  getFilterDataAll(data) {
    let resultado_chart = {};
    data.forEach(item => {
      resultado_chart[item.periodo] = resultado_chart[item.periodo] || {};
      resultado_chart[item.periodo].data = resultado_chart[item.periodo].data || [];
      resultado_chart[item.periodo].data.push([item.nombre, +item.valor]);
    });
    return resultado_chart;
  }
  processingDataRemote(serie, ubigeo, periodo) {
    let me = this;
    let ubigeo_values = "";
    let periodo_values = "";
    if (ubigeo && ubigeo.length > 0) {
      ubigeo.map(function (item) {
        ubigeo_values = (ubigeo_values === "" ? item.value : ubigeo_values + "," + item.value);
      });
    }
    if (periodo && periodo.length > 0) {
      periodo.map(function (item) {
        periodo_values = (periodo_values === "" ? item.value : periodo_values + "," + item.value);
      });
    }
    Api({
      query: "ANA04",
      serie: serie,
      ubigeo: ubigeo_values,
      periodo: periodo_values,
    }, function (items) {
      if (items.ANA04 && items.ANA04.data.length) {
        let resultado_chart = me.getFilterDataAll(items.ANA04.data);
        let _ambitos = [];
        let _periodos = [];
        let _data_ambitos = {};
        let _data_periodos = {};
        let _result = {};
        let _category = [];
        items.ANA04.data.forEach(item => {
          _ambitos[item.nombre] = item.nombre;
          _periodos[item.periodo] = item.periodo;
          _data_ambitos[item.ubigeo] = _data_ambitos[item.ubigeo] || {};
          _data_ambitos[item.ubigeo].data = [{ value: item.ubigeo + "0000", label: item.nombre }];
          _data_periodos[item.periodo] = _data_periodos[item.periodo] || {};
          _data_periodos[item.periodo].data = [{ value: item.periodo, label: item.periodo }];
          _result[item.ubigeo] = _result[item.ubigeo] || {};
          _result[item.ubigeo]['Region'] = item.nombre;
          _result[item.ubigeo][item.periodo] = +item.valor;
          _category[item.periodo] = item.periodo;
        });
        let store_chart_data = [];
        for (const key in resultado_chart) {
          let items = resultado_chart[key];
          store_chart_data.push(
            {
              name: _periodos[key],
              data: items.data
            }
          );
        }
        let chart_data = {
          category: Object.keys(_ambitos),
          datos: store_chart_data
        };
        let store_select_ambito = [];
        store_select_ambito.push({ value: '', label: 'Todos' });
        for (const key in _data_ambitos) {
          let item = _data_ambitos[key];
          store_select_ambito.push(item.data[0]);
        }
        let store_select_periodo = [];
        store_select_periodo.push({ value: '', label: 'Todos' });
        for (const key in _data_periodos) {
          let item = _data_periodos[key];
          store_select_periodo.push(item.data[0]);
        }
        let _grid_data = [];
        for (const key in _result) {
          let item = _result[key];
          _grid_data.push(item);
        }
        let _grid_header = [];
        _category.forEach(item => {
          _grid_header.push({
            'uniqueName': item,
            'aggregation': 'sum'
          });
        });
        me.setState({
          store_chart_data: chart_data,
          store_ambitos: me.state.store_ambitos.length > 0 ? me.state.store_ambitos : store_select_ambito,
          store_periodos: me.state.store_periodos.length > 0 ? me.state.store_periodos : store_select_periodo,
          grid_data: _grid_data,
          grid_header: {
            "rows": [{
              "uniqueName": "Region",
              "sort": "unsorted"
            }
            ],
            "columns": [{
              "uniqueName": "Measures",
              "sort": "unsorted"
            }],
            "measures": _grid_header
          }
        });
        me.setChart(chart_data.datos, chart_data.category);
      }
    });
  }
  setChart(data, category) {
    let me = this;
    this.chart.current.actualizarDatos(data, category);
    this.chart.current.actualizarOpciones({
      credits: {
        text: ""
      },
      title: {
        text: me.state.ficha_info.nombre
      },
      yAxis: {
        title: {
          text: me.state.ficha_info.unidad
        }
      }
    });
  }
  onChangeSerie(series) {
    let me = this;
    me.setState({
      store_series_default: series[0].value,
      store_ambitos_selected: [],
      store_ambitos: [],
      store_periodos: [],
      store_periodos_selected: [],
      new_store_serie: true,
      store_ambitos_default: [{ value: '', label: 'Todos' }],
      store_periodos_default: [{ value: '', label: 'Todos' }]
    }, () => me.processingDataRemote(series[0].value, me.state.store_ambitos_selected, me.state.store_periodos_selected));
  }
  onChangeAmbito(e) {
    let me = this;
    me.setState({
      store_ambitos_selected: e
    }, () => me.processingDataRemote(me.state.store_series_default, e, me.state.store_periodos_selected));
  }
  onChangePeriodo(e) {
    let me = this;
    me.setState({
      store_periodos_selected: e,
    }, () => me.processingDataRemote(me.state.store_series_default, me.state.store_ambitos_selected, e));
  }
  render() {
    let me = this;
    const {
      store_series,
      ficha_info,
      grid_header,
      grid_data,
      store_chart_data,
      store_ambitos,
      store_periodos,
      store_periodos_selected,
      store_ambitos_selected,
      store_series_selected
    } = this.state;
    return (
      <div className="container">
        <Row className="card-top">
          <Col>
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col xs={12} sm={12} md={7} xl={7}>
                    <Row>
                      <Col><span className="text-secondary">Indicador</span></Col>
                    </Row>
                    <Row>
                      <Col><h5><span className="text-white-50">{ficha_info.nombre}</span></h5></Col>
                    </Row>
                    <Row>
                      <Col><span className="text-secondary">(</span><span className="text-primary">{ficha_info.unidad})</span></Col>
                    </Row>
                  </Col>
                  <Col xs={12} sm={12} md={5} xl={5}>
                    <Row>
                      <Col><span className="text-secondary">Entidad productora</span></Col>
                    </Row>
                    <Row>
                      <Col><h5><span className="text-white-50">{ficha_info.fuente}</span></h5></Col>
                    </Row>
                    <Row>
                      <Col>{ficha_info.dependencia}</Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter />
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="card-stats">
              <CardBody>
                <Row className="mb-2">
                  <Col xs={12} sm={12} md={2} xl={2}>
                    <p>Series de datos</p>
                  </Col>
                  <Col xs={12} sm={12} md={4} xl={4}>
                    <SelectSerie store={store_series} item_default={store_series_selected} onChange={me.onChangeSerie}/>
                  </Col>
                  <Col xs={12} sm={12} md={6} xl={6}>
                    <p className="text-right">
                      <span>
                        <a
                          href="javascrpt:"
                          className="text-right"
                          onClick={() => this.showModal()}
                        >
                          <i className="far fa-clipboard"></i> {" "}Ver Ficha Divulgación
                      </a>
                      </span>
                    </p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <Row className="mt-3 mr-2">
                <Col xs={12} sm={12} md={2} xl={6}>

                </Col>
                <Col xs={12} sm={12} md={4} xl={3}>
                  Ámbito <Select nullable={false} item_all={true} multiple={true} store={store_ambitos} onChange={me.onChangeAmbito} item_selected={store_ambitos_selected} />
                </Col>
                <Col xs={12} sm={12} md={6} xl={3}>
                  Periodo <Select nullable={false} item_all={true} multiple={true} store={store_periodos} onChange={me.onChangePeriodo} item_selected={store_periodos_selected} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Card>
                    <CardBody>
                      <div>
                        <SiniaCustomChart
                          exportable={true}
                          multiSeries={true}
                          chartType={"column"}
                          titleTpl={`${ficha_info.nombre}`}
                          yAxeTitle={`${ficha_info.unidad}`}
                          xAxeTitle="Periodos"
                          source={`${ficha_info.fuente}{" - "}${ficha_info.dependencia}`}
                          ref={this.chart}
                          data={store_chart_data.datos}
                        />
                      </div>
                      <Modal className="ficha-popup" isOpen={this.state.isModalOpen}>
                        <ModalHeader> Ficha de divulgación</ModalHeader>
                        <ModalBody>
                          <div >
                            <Row>
                              <Col><span className="text-primary"><i className="fas fa-angle-right"></i> Nombre</span></Col>
                            </Row>
                            <Row>
                              <Col><span className="text-secondary">{ficha_info.nombre}</span></Col>
                            </Row>
                            <Row>
                              <Col><span className="text-primary"><i className="fas fa-angle-right"></i> Descripción</span></Col>
                            </Row>
                            <Row>
                              <Col><span className="text-secondary">...</span></Col>
                            </Row>
                            <Row>
                              <Col><span className="text-primary"><i className="fas fa-angle-right"></i> Finalidad</span></Col>
                            </Row>
                            <Row>
                              <Col><span className="text-secondary">...</span></Col>
                            </Row>
                            <Row>
                              <Col><span className="text-primary"><i className="fas fa-angle-right"></i> Limitaciones</span></Col>
                            </Row>
                            <Row>
                              <Col><span className="text-primary">...</span></Col>
                            </Row>
                            <Row>
                              <Col><span className="text-primary"><i className="fas fa-angle-right"></i> Método de cálculo</span></Col>
                            </Row>
                            <Row>
                              <Col><span className="text-secondary">...</span></Col>
                            </Row>
                            <Row>
                              <Col><span className="text-primary"><i className="fas fa-angle-right"></i> Enlaces</span></Col>
                            </Row>
                            <Row>
                              <Col><span className="text-secondary">...</span></Col>
                            </Row>
                            <Row>
                              <Col><span className="text-primary"><i className="fas fa-angle-right"></i> Descriptores</span></Col>
                            </Row>
                            <Row>
                              <Col><span className="text-secondary">...</span></Col>
                            </Row>
                            <Row>
                              <Col><span className="text-primary"><i className="fas fa-angle-right"></i> Series disponibles</span></Col>
                            </Row>
                            <Row>
                              <Col>
                                {store_series.length > 0 ? (
                                  <ul>
                                    {store_series.map(function (item, key) {
                                      return (
                                        <li key={key}> {item.label}</li>
                                      );
                                    })}
                                  </ul>
                                ) : (
                                    <div>
                                      <span className="text-secondary">...</span>
                                    </div>
                                  )}
                              </Col>
                            </Row>
                          </div>
                        </ModalBody>
                        <ModalFooter>
                          <Button color="primary" onClick={this.toggle}>Aceptar</Button>
                        </ModalFooter>
                      </Modal>
                    </CardBody>
                    <CardFooter>
                      Fuente : {ficha_info.fuente}{" - "}{ficha_info.dependencia}
                    </CardFooter>
                  </Card>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="mx-auto text-center mb-1">
              <span>Tabla de datos</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12} xs={12}>
            <Card>
              <CardBody>
                <div>
                  {grid_data.length > 0 ? (
                    <WebDataRocksReact.Pivot toolbar={true} datasource={grid_data} slice={grid_header} />
                  ) : (
                      <div>
                        No hay datos
    </div>
                    )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Ficha;
